/* eslint-disable */
import {
  Grid,
  RACButton,
  RACModalCard,
  Typography,
} from "@rentacenter/racstrap";
import { ReactComponent as SuccessIcon } from '../../assets/img/success-icon.svg';
import { useEffect, useState } from "react";

interface ScannedCategoryModalProps {
  alertMessage: string;
  alertType: string;
  onAdjustFn: (value: boolean) => any;
  onKeepFn: (value: boolean) => any;
}

export function ScannedCategoryModal(props: ScannedCategoryModalProps) {
  const { alertMessage, alertType, onAdjustFn, onKeepFn } = props;
  const [message, setMessage] = useState<string>(alertMessage ||  "");

  useEffect(() => { }, [message, alertType]);

  const scannedCategoryModalContent = () => (
    <Grid container>
      <Grid item md={12} style={{ textAlign: "center", position: "relative" }}>
       {alertType === 'success' ? (
                 <SuccessIcon />
               ) : []}
        <Typography
          variant={"body2"}
          style={{
            textAlign: "center",
            fontSize: "14px",
            letterSpacing: 0,
            marginBottom: "25px",
            marginTop: '15px'
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: message }}></div>
        </Typography>
        <RACButton
          variant="contained"
          color="primary"
          id="assignAlertBtn"
          style={{
            textAlign: "center",
            margin: '15px'
          }}
          onClick={() => {
            onAdjustFn(false); // Mark for opt-out
         }}
        >ADJUST</RACButton>

        <RACButton
          variant="contained"
          color="primary"
          id="assignAlertBtn"
           style={{
            textAlign: "center",
            margin: '15px'
          }}
          onClick={() => {
            onKeepFn(true); // Mark for opt-out
          }}
        >KEEP</RACButton>
      </Grid>
    </Grid>
  );
  return (
    <>
      <RACModalCard
        borderRadius="20px"
        isOpen={true}
        maxWidth="xs"
        children={scannedCategoryModalContent()}
      />
    </>
  );
}

